import { HTTPMethod } from "@kuika/kuika-cl-model/src/dtos/datasource.dto";
import * as React from "react";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";

/** The one request an endpoint describes: a method and a path under the collection's base URL. */
export interface IRestEndpointRequest {
  method?: HTTPMethod;
  path?: string;
}

export interface IRestEndpointRequestRowProps {
  /** Supplied by the form field this sits in. */
  value?: IRestEndpointRequest;
  onChange?: (value: IRestEndpointRequest) => void;
  onRun: () => void;
  isRunning?: boolean;
  error?: boolean;
}

const METHODS: HTTPMethod[] = ["GET", "POST", "PUT", "DELETE"];

const methodOptions: KuikaSelectboxOption[] = METHODS.map((method: HTTPMethod): KuikaSelectboxOption => ({
  value: method,
  label: <span className={`kuika-connection-form__method kuika-connection-form__method--${method}`}>{method}</span>,
  searchLabel: method
}));

/**
 * Method, path and Run, as one row. Run reaches the endpoint without saving it, and the
 * response it brings back is what the Body section then shows.
 */
export const RestEndpointRequestRow = ({
  value,
  onChange,
  onRun,
  isRunning,
  error
}: IRestEndpointRequestRowProps): React.ReactElement => {
  const request: IRestEndpointRequest = value ?? { method: "GET", path: "" };

  const change = (next: IRestEndpointRequest): void => {
    onChange?.({ ...request, ...next });
  };

  return (
    <div className={`kuika-connection-form__request-row${error ? " kuika-connection-form__request-row--error" : ""}`}>
      <KuikaSelectbox
        size="md"
        className="kuika-connection-form__method-select"
        options={methodOptions}
        value={request.method ?? "GET"}
        onChange={(method) => change({ method: method as HTTPMethod })}
        data-testid="restApiEndpointMethodSelect"
      />
      <KuikaInput
        size="md"
        borderless
        type="text"
        placeholder="items"
        leftIcon={<span className="kuika-connection-form__path-prefix">/</span>}
        value={request.path ?? ""}
        onChange={(_event, path) => change({ path: String(path) })}
        data-testid="restApiEndpointInput"
      />
      <KuikaButton
        type="secondary"
        size="md"
        className="kuika-connection-form__run-button"
        onClick={onRun}
        loading={isRunning}
        data-testid="restApiEndpointRunButton"
      >
        <KuikaSvg name="player-play" width={13} height={14} />
        RUN
      </KuikaButton>
    </div>
  );
};
